/* ROUVRE (gabarit Vivélan) : galerie, dates de livraison, menu, vidéos, barre fixe d'achat du bâton (ajout au panier), fenêtre de secours vers la fiche. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var modal = $('#ckv-modal');
  $$('[data-vitrine]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); modal.classList.add('is-open'); }); });
  $$('[data-close]', modal).forEach(function (el) { el.addEventListener('click', function () { modal.classList.remove('is-open'); }); });

  var drawer = $('#ckv-drawer');
  $$('[data-drawer]').forEach(function (el) { el.addEventListener('click', function () { drawer.classList.add('is-open'); }); });
  $$('[data-drawer-close], #ckv-drawer a').forEach(function (el) { el.addEventListener('click', function () { drawer.classList.remove('is-open'); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { modal.classList.remove('is-open'); drawer.classList.remove('is-open'); } });

  // Galerie : vignettes synchronisées
  var track = $('.ckv-gal__track'), thumbs = $$('.ckv-gal__th button');
  if (track) {
    var imgs = $$('img', track);
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { track.scrollTo({ left: imgs[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }, { passive: true });
  }

  // Offre : prix affiché partout, aucun ajout au panier
  var opts = $$('.ckv-opt');
  opts.forEach(function (o) {
    $('input', o).addEventListener('change', function () {
      opts.forEach(function (x) { x.classList.toggle('is-on', x === o); });
      $$('[data-prix]').forEach(function (p) { p.textContent = o.getAttribute('data-total'); });
      $$('[data-barre]').forEach(function (p) { if (p.tagName === 'S') p.textContent = o.getAttribute('data-barre'); });
    });
  });

  // Dates indicatives (jours ouvrés)
  function plus(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }); }
  $$('[data-d]').forEach(function (el) {
    var r = el.getAttribute('data-d').split('-').map(Number);
    el.textContent = r.length === 1 ? fmt(plus(r[0])) : fmt(plus(r[0])) + ' – ' + fmt(plus(r[1]));
  });

  // Vidéos : lecture au clic, une seule à la fois
  var cards = $$('.ckv-vid__t');
  function stopAll(except) { cards.forEach(function (c) { var v = $('video', c); if (c !== except && !v.paused) v.pause(); }); }
  cards.forEach(function (c) {
    var v = $('video', c);
    v.addEventListener('play', function () { c.classList.add('is-playing'); });
    v.addEventListener('pause', function () { c.classList.remove('is-playing'); });
    c.addEventListener('click', function () {
      if (v.paused) { stopAll(c); var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    });
  });
  // Pause automatique quand la carte sort de l'écran
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (!e.isIntersecting) $('video', e.target).pause(); });
    }, { threshold: 0.2 });
    cards.forEach(function (c) { vio.observe(c); });
  }

  // Avis : « Voir plus d'avis » déplie les cartes masquées
  $$('[data-plus-avis]').forEach(function (b) {
    b.addEventListener('click', function () {
      var l = b.parentNode.querySelector('[data-rvs]'); if (l) l.classList.add('is-ouvert');
      b.setAttribute('aria-expanded', 'true'); b.style.display = 'none';
    });
  });

  // Variante bureau du hero : ?hero=bureau
  if (/[?&]hero=bureau/.test(location.search)) {
    $$('[data-hero] [data-bureau]').forEach(function (el) {
      var v = el.getAttribute('data-bureau');
      if (el.tagName === 'SOURCE') el.srcset = v; else if (el.tagName === 'IMG') el.src = v; else el.textContent = v;
    });
  }

  // Barre fixe ROUVRE : visible après le haut de page, masquée quand le bloc d'achat ROUVRE est à l'écran
  var sticky = $('.ckv-sticky'), buy = $('.ckv-pr__form'), buyVu = false;
  if (sticky) {
    var maj = function () { sticky.classList.toggle('is-on', window.scrollY > 500 && !buyVu); };
    if (buy && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { buyVu = en[0].isIntersecting; maj(); }).observe(buy);
    window.addEventListener('scroll', maj, { passive: true }); maj();
  }

  // Ajout direct du bâton au panier (barre fixe), puis page panier ; formulaire classique si fetch manque
  $$('[data-rv-add]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.fetch) return; e.preventDefault();
      var b = $('button', f); b.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +$('[name=id]', f).value, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; location.href = '/cart'; })
        .catch(function () { b.disabled = false; location.href = '/#acheter'; });
    });
  });
})();

